import { MatMenuModule } from '@angular/material/menu'
import { Component, inject, OnInit, signal } from '@angular/core'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { CommonModule } from '@angular/common'
import { MatButtonModule } from '@angular/material/button'
import { LoadingPageComponent } from '@monorepo-channels/components/ui-pm'
import { Store } from '@ngrx/store'

import { ReactiveFormsModule } from '@angular/forms'
import {
	CuisineActions,
	getCuisines,
	getStatusCuisine,
	VenueActions,
} from '@monorepo-channels/channels/domain'
import { FilterState } from '../filter.state'
import { isMobile } from '@monorepo-channels/shared/util-helpers'

@Component({
	standalone: true,
	imports: [
		CommonModule,
		MatFormFieldModule,
		MatIconModule,
		MatButtonModule,
		LoadingPageComponent,
		ReactiveFormsModule,
		MatMenuModule,
	],
	selector: 'feature-porto-bank-categories-cuisines',
	templateUrl: './categories-cuisines.component.html',
	styleUrls: ['./categories-cuisines.component.scss'],
})
export class CategoriesCuisinesComponent implements OnInit {
	private store = inject(Store)
	public filterState = inject(FilterState)
	open = signal(false)

	public selectedCategory = this.filterState.selectedCategory
	public selectedCuisine = this.filterState.selectedCuisine
	public selectedBenefitIds = this.filterState.selectedBenefitIds
	public isMobile = isMobile()

	public cuisines$ = this.store.select(getCuisines)
	public statusCuisines$ = this.store.select(getStatusCuisine)

	constructor() {
		if (this.filterState.count() === 0) this.filterState.resetState()
	}

	ngOnInit(): void {
		this.store.dispatch(CuisineActions.getCuisines())
	}

	cleanFilter() {
		this.filterState.resetState()
		this.filterState.assignCount()
		this.store.dispatch(VenueActions.cleanIncludeBenefits())
		this.store.dispatch(VenueActions.cleanExcludeBenefits())
		this.store.dispatch(CuisineActions.cleanCuisines())
		this.store.dispatch(VenueActions.cleanCategories())
		this.store.dispatch(VenueActions.applyFilter())
		this.open.set(false)
	}

	applyFilter() {
		this.filterState.assignCount()
		this.store.dispatch(CuisineActions.setCurrentCuisine({ cuisines: this.selectedCuisine() }))
		this.store.dispatch(VenueActions.setCurrentCategories({ categories: this.selectedCategory() }))
		this.store.dispatch(
			VenueActions.setCurrentIncludeBenefits({ includeBenefits: this.selectedBenefitIds() })
		)
		// this.store.dispatch(
		//     VenueActions.setCurrentExcludeBenefits({ excludeBenefits: this.selectedExcludeBenefitIds() })
		// )
		this.store.dispatch(VenueActions.applyFilter())
		this.open.set(false)
	}

	toggle() {
		this.open.update(value => !value)
	}

	close() {
		this.open.set(false)
	}
}
